import { render, staticRenderFns } from "./deleteSmallWechat.vue?vue&type=template&id=3036e0a5&scoped=true"
import script from "./deleteSmallWechat.vue?vue&type=script&lang=js"
export * from "./deleteSmallWechat.vue?vue&type=script&lang=js"
import style0 from "./deleteSmallWechat.vue?vue&type=style&index=0&id=3036e0a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036e0a5",
  null
  
)

export default component.exports